import { InjectionToken } from '@angular/core';
import { NavigationLink } from '../models';

export const NAV_LINK = new InjectionToken<NavigationLink[]>('NAV_LINKS');
